module.exports = __webpack_public_path__ + "static/media/picture-(126).6cd7ec63.JPG";